<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="600"
  >
    <v-card>
      <v-card-text class="pa-8 text-center">
        <h3 class="mb-6">
          {{ message }}
        </h3>
        
        <v-checkbox
          v-model="updateStatusToJwnetRequested"
          class="mt-4"
          hide-details
        >
          <template v-slot:label>
            <span class="body-2">排出事業者のステータス「排出申請済」を「JWNET登録中」に更新する</span>
          </template>
        </v-checkbox>
        
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="onCancel">
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          @click="onExecute"
        >
          実行
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CsvExportChargesDialog',
  props: {
    message: {
      type: String,
      default: '「排出申請済」のJWNET登録用データ（C料金）を出力しますか？'
    }
  },
  data () {
    return {
      show: false,
      resolve: null,
      updateStatusToJwnetRequested: true
    }
  },
  methods: {
    open () {
      this.updateStatusToJwnetRequested = true
      this.show = true
      
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    close () {
      this.show = false
    },
    onExecute () {
      this.resolve({
        confirmed: true,
        updateStatus: this.updateStatusToJwnetRequested
      })
      this.close()
    },
    onCancel () {
      this.resolve({
        confirmed: false,
        updateStatus: false
      })
      this.close()
    }
  }
}
</script>

<style scoped>
</style>
